(function(){
  function getRoot(){
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function initCard(card){
    if (!card || card.dataset.avCard11Ready === 'true') return;
    card.dataset.avCard11Ready = 'true';

    var primaryImage = card.querySelector('.av-card11__image--primary');
    var thumbs = card.querySelectorAll('[data-av-card11-thumb]');
    if (primaryImage && thumbs.length) {
      thumbs.forEach(function(thumb){
        var update = function(){
          var src = thumb.getAttribute('data-image');
          if (!src) return;
          primaryImage.removeAttribute('srcset');
          primaryImage.src = src;
          thumbs.forEach(function(item){ item.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        };
        thumb.addEventListener('mouseenter', update);
        thumb.addEventListener('focus', update);
        thumb.addEventListener('click', function(event){ event.preventDefault(); update(); });
      });
    }

    var form = card.querySelector('.av-card11__form');
    if (!form || !window.fetch || !window.FormData) return;

    form.addEventListener('submit', function(event){
      event.preventDefault();
      var button = form.querySelector('[data-av-card11-submit]');
      var label = form.querySelector('[data-av-card11-button-text]');
      var defaultText = button ? button.getAttribute('data-default-text') : '';
      if (button) {
        button.classList.add('is-loading');
        button.disabled = true;
      }
      if (label) label.textContent = 'Adicionando';

      fetch(getRoot() + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin'
      })
      .then(function(response){
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function(item){
        if (button) {
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.disabled = false;
        }
        if (label) label.textContent = 'Adicionado';
        document.dispatchEvent(new CustomEvent('av:cart:add', { detail: { item: item, productId: card.getAttribute('data-product-id') } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.setTimeout(function(){
          if (button) button.classList.remove('is-added');
          if (label) label.textContent = defaultText || 'Adicionar';
        }, 1800);
      })
      .catch(function(){
        if (button) {
          button.classList.remove('is-loading');
          button.disabled = false;
        }
        if (label) label.textContent = defaultText || 'Adicionar';
        form.submit();
      });
    });
  }

  function initAll(context){
    (context || document).querySelectorAll('[data-av-card11]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event){ initAll(event.target); });
})();
